<script setup>
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { storeToRefs } from 'pinia'

// const acceptPublicInvestmentConsent = ref(false)

const store = useInvestmentProcessDataState()
const { acceptPublicInvestmentConsent } = storeToRefs(store)
</script>

<template>
    <div class="relative flex items-start pt-4">
        <div class="flex h-6 items-center">
            <input
                id="comments"
                v-model="acceptPublicInvestmentConsent"
                aria-describedby="comments-description"
                name="comments"
                type="checkbox"
                class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
        </div>
        <div class="ml-3 text-sm leading-6">
            <label for="comments" class="font-semibold text-gray-900">{{
                $t('investment_process.public_name_consent')
            }}</label>
        </div>
    </div>
</template>

<style scoped></style>
